import { z } from 'zod';

const EnvSchema = z.object( {
  // Node
  NODE_ENV: z.enum( ['development', 'production', 'test'] ),
  REACT_APP_SENTRY_ENVIRONMENT: z.string().or( z.literal( '' ) ),
  // API
  REACT_APP_API_URL: z.string().url(),
  REACT_APP_CLIENT_SECRET: z.string().min( 1 ),
  REACT_APP_CLIENT_ID: z.string().min( 1 ),
  REACT_APP_TWO_FACTOR_AUTH_CLIENT_SECRET: z.string().min( 1 ),
  REACT_APP_TWO_FACTOR_AUTH_CLIENT_ID: z.string().min( 1 ),
} );

const env = EnvSchema.parse( process.env );

export { env };
